import React from 'react';
import styled from 'styled-components/native'; // Keep unified with native elements
import { Platform } from 'react-native';
import { AppTextView } from '@/components/base/app.text.view';
import { AppButton } from '@/components/base/app.button';
import { Box } from '@/components/base/box';
import { usePwaInstall } from '@/hooks/use.pwa.install';
import { AppIconButton } from '@/components/base/app.icon.button';
import { wpVal } from '../../utils';

export function PwaInstallBanner() {
  // Pull data safely from context without blocking root initialization layout
  const { isInstallable, handleInstallClick, handleCancel } = usePwaInstall();

  // Safety checklist guardrails
  if (Platform.OS !== 'web' || !isInstallable) return null;

  return (
    <BannerContainer>
      <AppIconButton icon={'close'} onPress={handleCancel} />
      <AppTextView text="سایت مطپ را نصب کنید تا دسترسی راحت‌ تری داشته باشید" textColor="white" />
      <InstallButton title="نصب برنامه" fontSize={'small'} variant={'orange'} onPress={handleInstallClick} />
    </BannerContainer>
  );
}

const BannerContainer = styled(Box)`
  position: fixed;
  bottom: 20px;
  right: ${wpVal(2)};
  margin-left: ${wpVal(2)};
  background-color: #50bcbd;
  padding: 15px;
  border-radius: 12px;
  gap: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9999;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  flex-direction: row-reverse; /* Matches RTL for your Persian strings */
`;

const InstallButton = styled(AppButton)`
  width: auto;
  padding-horizontal: 16px;
  height: 36px;
`;
